export default __webpack_public_path__ + "static/media/en_construccion.4c181860.jpg";